/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowYogaRetreatTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowYogaRetreat,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Find Your Zen!",
    "Relax and Recharge!",
    "Yoga Bliss Awaits!",
  ],
  title: "Yoga Retreat",
  description: "Organize a rejuvenating yoga retreat.",
  longDescription:
    "Gather your friends for a calming yoga retreat! Choose a date, decide on a location, and plan activities to relax and recharge!",
  emoji: "🧘",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Yoga Retreat",
          emoji: "🧘",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the yoga retreat?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a location for the retreat?",
            description: "Where do we want to hold our yoga retreat?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What location should we choose?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on activities?",
                  description:
                    "What activities should we plan for the retreat?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we include?",
                      emoji: "🌅",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Namaste!",
    outroDescription:
      "Your yoga retreat plans are set! Enjoy the peace and tranquility!",
  },
};
